export default __webpack_public_path__ + "static/grouped-bar-21d06207eceaeb18f47b47b2d74e99d0.png";